import React from 'react';
import './Headerpage.css';
import logoImg from './img/RootServices.jpeg';

function Headerpage() {
  return (
    <header className="headerpage-container">
      <div className="headerpage-header">
        <img
          src={logoImg}
          alt="Root Services"
          className="headerpage-logo"
        />
        <h1 className="headerpage-title">Root Services Dashboard</h1>
      </div>
    </header>
  );
}

export default Headerpage;
